import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DrawerService {
  private menuDrawerToggleSource = new Subject<'open' | 'close' | 'toggle'>();
  private cartDrawerToggleSource = new Subject<'open' | 'close' | 'toggle'>();

  menuDrawerToggle$ = this.menuDrawerToggleSource.asObservable();
  cartDrawerToggle$ = this.cartDrawerToggleSource.asObservable();

  openMenu() {
    this.menuDrawerToggleSource.next('open');
  }

  closeMenu() {
    this.menuDrawerToggleSource.next('close');
  }

  toggleMenu() {
    this.menuDrawerToggleSource.next('toggle');
  }

  openCart() {
    this.cartDrawerToggleSource.next('open');
  }

  closeCart() {
    this.cartDrawerToggleSource.next('close');
  }

  toggleCart() {
    this.cartDrawerToggleSource.next('toggle');
  }
}
